import api from "./apiBase";

function registerUser(data) {
  return api.post("/users", data);
}

function getUserInfoById() {
  return api.get("/users?include=addresses");
}

function updateUser(data) {
  return api.patch("/users", data, {
    headers: { "Content-Type": "application/json" },
  });
}

function addAddress(data) {
  return api.post("/users/addresses", data);
}

function removeAddress(id) {
  return api.delete("/users/addresses/" + id);
}

function editAddress(id, data) {
  return api.patch("/users/addresses/" + id, data);
}

function getAddressesWithPagination(params = {}) {
  const query = new URLSearchParams(params).toString();
  return api.get(`/users/addresses?${query}`);
}

export {
  registerUser,
  getUserInfoById,
  updateUser,
  addAddress,
  removeAddress,
  editAddress,
  getAddressesWithPagination,
}